module.exports = __webpack_public_path__ + "static/media/blueprint-bg.0f49f9a8.svg";